// extracted by mini-css-extract-plugin
export default {"noMapping":"TimestampAndTimelapse_noMapping__dIR16","timestamp":"TimestampAndTimelapse_timestamp__3g-kJ"};